import React , {Component} from "react";
import {  Formik, Form, Field } from 'formik';
import axios from 'axios';
import { MenuItem, LinearProgress, Fab, Typography, Grid, Breadcrumbs, Modal, Backdrop, Fade, Accordion, AccordionSummary, AccordionDetails } 
from '@mui/material';
import { styled } from "@mui/material/styles";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as yup from 'yup';
import {Link, useParams} from 'react-router-dom';
import { TextField } from 'formik-mui';
import Button from "../../components/CustomButtons/Button.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import Card from "../../components/Card/Card.jsx";
import CardHeader from "../../components/Card/CardHeader.jsx";
import CardBody from "../../components/Card/CardBody";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import InsertPhotoIcon from '@mui/icons-material/InsertPhoto';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import AttachFileIcon from '@mui/icons-material/AttachFile';
import { connect } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import LazyCKEditor from "../../components/shared/LazyCKEditor.jsx";
import withRouterCompat from '../../actions/routerWrapper.jsx';
import { baseUrl } from '../../components/shared/baseUrl.js';


function Createmod() {
  return (
    <LazyCKEditor
      data="<p>Start writing here...</p>"
      onChange={(event, editor) => {
        console.log(editor.getData());
      }}
    />
  );
}

const mapStateToProps = (state) => {
    // console.log(state)
  
    return {
    user: state.user
     }
  };

const StyledPaper = styled('div')(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    border: '2px solid #000',
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
    width: 1000,
}));

const StyledModal = styled('div')({
     alignItems: 'center',
    justifyContent: 'center',
    position:'absolute',
    top:'20%',
    left:'10%',
    overflowY:'scroll',
    height:'100%',
    display:'block'
});

const StyledcardTitle = styled('div')({
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none"
});

const StyledRoot = styled('div')(({ theme }) => ({
    
        width: 500,
        '& > * + *': {
          marginTop: theme.spacing(3),
        },
}));

const StyledHeading = styled('div')(({ theme }) => ({
    
        fontSize: theme.typography.pxToRem(15),
        flexBasis: '33.33%',
        flexShrink: 0,
}));

const StyledSecondaryHeading = styled('div')(({ theme }) => ({
        fontSize: theme.typography.pxToRem(15),
        color: theme.palette.text.secondary,
}));

const StyledcardCategory = styled('div')({
    color: "rgba(255,255,255,.62)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0"
});

const styles = (theme) =>({
   
    cardCategoryWhite: {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    }
    
  });

const standard = [
    {
        value: 'VI',
        label: 'VI'
    },
    {
        value: 'VII',
        label: 'VII'
    },
    {
        value: 'VIII',
        label: 'VIII'
    },
    {
        value: 'IX',
        label: 'IX'
    },
    {
        value: 'X',
        label: 'X'
    },
    {
        value: 'XI',
        label: 'XI'
    },
    {
        value: 'XII',
        label: 'XII'
    }

]

const language = [
    {
        value: 'English',
        label: 'English'
    },
    {
        value: 'Hindi',
        label: 'Hindi'
    },
    {
        value: 'Bengali',
        label: 'Bengali'
    }
]

const levelmod = [
    {
        value: '1',
        label: '1(Demonstrated)'
    },
    {
        value: '2',
        label: '2(Structured)'
    },
    {
        value: '3',
        label: '3(Guided)'
    },
    {
        value: '4',
        label: '4(Self-Directed)'
    }

]

const subject = [
    {
        value: 'Physics',
        label: 'Physics'
    },
    {
        value: 'Chemistry',
        label: 'Chemistry'
    },
    {
        value: 'Biology',
        label: 'Biology'
    },
    {
        value: 'Mathematics',
        label: 'Mathematics'
    }

]
const previewStyle = {
    maxHeight: "200px",
    maxWidth: "200px"
  }

  const validationSchema = yup.object().shape({
  
    title: yup
      .string()
      .min(6, "Title is too short ")
      .required('Please enter an appropriate title'),
  
    language: yup
        .string()
        .required('Please enter the language'),
  
    description: yup
      .string()
      .min(2, "Too Short")
      .max(100, "Too Long!")
      .required('Please enter an appropriate description'),
      
  
    level:yup
        .string().required('Please enter the level of module'),

    subject:yup
        .string().required('Please enter the subject of module'),

    std:yup
        .string().required('Please enter the standard/class'),

  
    
  })

  function findUnique(arr, predicate) {
    var found = {};
    arr.forEach(d => {
      found[predicate(d)] = d;
    });
    return Object.keys(found).map(key => found[key]); 
  }

  const custom_config = {
    extraPlugins: [ MyCustomUploadAdapterPlugin ],
    
    toolbar: {
      items: [
        'heading',
        '|',
        'bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        '|',
        'blockQuote',
        'insertTable',
        '|',
        'imageUpload',
        'undo',
        'MathType',
        'SpecialCharacters',
        'SpecialCharactersMathematical',
        'redo',
        'Subscript', 
        'Superscript',            
      ]
    }
    ,
    table: {
      contentToolbar: [ 'tableColumn', 'tableRow', 'mergeTableCells' ]
    }
  }

        //////Code for ckeditor
        function MyCustomUploadAdapterPlugin(editor){
            editor.plugins.get( 'FileRepository' ).createUploadAdapter = (loader) => {
              return new MyUploadAdapter(loader)
            }
          }
      
          class MyUploadAdapter {
            constructor(props) {
                // CKEditor 5's FileLoader instance.
              this.loader = props;
              // URL where to send files.
              this.url = `http://localhost:5000/fileupload/files`;
            }
        
            // Starts the upload process.
            upload() {
              return this.loader.file
                  .then( file => new Promise( ( resolve, reject ) => {
      
                      const toBase64 = file => new Promise((resolve, reject) => {
                          const reader = new FileReader();
                          reader.readAsDataURL(file);
                          reader.onload = () => resolve(reader.result);
                          reader.onerror = error => reject(error);
                      });
                      
                      return toBase64(file).then(cFile=>{
                        console.log(file)
                        const data=new FormData();
                        data.append('file', file)   
                        var filename = '';
                      axios.post(`http://localhost:5000/fileupload/files`, data)
                              .then((response) => {
                                  console.log(response.data.file.filename)
                                  filename = response.data.file.filename;
                                  resolve({ 
                                    default: `http://localhost:5000/fileupload/files/${filename}` 
                                  })
                              })
                              .catch((error)=>{
                                  reject(`Couldn't upload file: ${ file.name }.`)
                                console.log(error);
                                });
                              })
                      
                  } ) );
          }
        
        }
      


class CreateModule extends Component {

    constructor(props) {
        super(props)
        this.state = {
            file: '',
            simfile:'',
            imagefile:'',
            backfile:'',
            matfile:'',
            methodfile:'',
            analysisfile:'',
            url: '',
            imageurl:'',
            backurl:'',
            maturl:'',
            methodurl:'',
            analysisurl:'',
            youtube:'',
            task:'',
            backGround:'',
            backGroundImage:'',
            backGroundYou:'',
            material:'',
            materialImage:'',
            materialYou:'',
            method:'',
            methodImage:'',
            methodYou:'',
            analysis:'',
            analysisImage:'',
            analysisYou:'',
            simulation_name:'',
            simulation:'',
            intro:'',
            intro_image:'',
            modimage:'',
            uploadSuccess:false,
            uploadSimSuccess:false,
            uploadImageSuccess:false,
            userstate:[],
            topic:[],
            preview:false,
            level:'1',
            open: false,
            isLoading:true,
            module:[],
            errorIntro:'',
            errorTopic:'',
            errorBack:'',
            errorTask:'',
            errorMaterial:'',
            errorMethod:'',
            errorAnalysis:'',
            expanded:false
        };

        this.myRef = React.createRef();
        this.handleUploadClick = this.handleUploadClick.bind(this);
        this.handleSimUploadClick = this.handleSimUploadClick.bind(this);
        this.handleImageUploadClick = this.handleImageUploadClick.bind(this);
        this.handleBackUploadClick = this.handleBackUploadClick.bind(this);
        this.handleMaterialUploadClick = this.handleMaterialUploadClick.bind(this);
        this.handleMethodUploadClick = this.handleMethodUploadClick.bind(this);
        this.handleAnalysisUploadClick = this.handleAnalysisUploadClick.bind(this);
        this.uploadbutton = this.uploadbutton.bind(this);
        this.cancelbutton = this.cancelbutton.bind(this);
        this.cancelSimbutton = this.cancelSimbutton.bind(this);
        this.cancelImagebutton = this.cancelImagebutton.bind(this);
        this.cancelBackGroundbutton = this.cancelBackGroundbutton.bind(this);
        this.cancelMaterialbutton = this.cancelMaterialbutton.bind(this);
        this.cancelMethodbutton = this.cancelMethodbutton.bind(this);
        this.cancelAnalysisbutton = this.cancelAnalysisbutton.bind(this);
        this.uploadsimbutton = this.uploadsimbutton.bind(this);
        this.uploadimagebutton = this.uploadimagebutton.bind(this);
        this.uploadimageBackbutton = this.uploadimageBackbutton.bind(this);
        this.uploadimageMaterialbutton = this.uploadimageMaterialbutton.bind(this);
        this.uploadimageMethodbutton = this.uploadimageMethodbutton.bind(this);
        this.uploadimageAnalysisbutton = this.uploadimageAnalysisbutton.bind(this);
        this.handlevideo=this.handlevideo.bind(this);
        this.handleBackvideo=this.handleBackvideo.bind(this);
        this.handleMaterialvideo=this.handleMaterialvideo.bind(this);
        this.handleMethodvideo=this.handleMethodvideo.bind(this);
        this.handleAnalysisvideo=this.handleAnalysisvideo.bind(this);
        this.onenable=this.onenable.bind(this);
        this.htmlPage=this.htmlPage.bind(this);
        this.fetchUser=this.fetchUser.bind(this);
        this.handlelevelChange=this.handlelevelChange.bind(this);
        this.handleClosePreview=this.handleClosePreview.bind(this);
        this.getPreview=this.getPreview.bind(this);
        this.validateTopic=this.validateTopic.bind(this);
        this.validateAnalysis=this.validateAnalysis.bind(this);
        this.handleAnalysisChange=this.handleAnalysisChange.bind(this);
        this.validateMethod=this.validateMethod.bind(this);
        this.handleMethodChange=this.handleMethodChange.bind(this);
        this.validateMaterial=this.validateMaterial.bind(this);
        this.handleMaterialChange=this.handleMaterialChange.bind(this);
        this.validateTask=this.validateTask.bind(this);
        this.handleTaskChange=this.handleTaskChange.bind(this);
        this.validateSimName=this.validateSimName.bind(this);
        this.handleSimNameChange=this.handleSimNameChange.bind(this);
        this.handleChange=this.handleChange.bind(this);
        this.onEditorStateChange=this.onEditorStateChange.bind(this);
        this.uploadImageCallBack=this.uploadImageCallBack.bind(this);
        this.onEditorBackGroundStateChange=this.onEditorBackGroundStateChange.bind(this);
        this.onEditorTaskStateChange=this.onEditorTaskStateChange.bind(this);
        this.onEditorMaterialStateChange=this.onEditorMaterialStateChange.bind(this);
        this.onEditorMethodStateChange=this.onEditorMethodStateChange.bind(this);
        this.onEditorAnalysisStateChange=this.onEditorAnalysisStateChange.bind(this);
        this.handleAccordionChange=this.handleAccordionChange.bind(this);

    }
     
    CancelToken = axios.CancelToken;
    source = this.CancelToken.source();
    abortController = new AbortController();
    
    fetchUser = async () => {

        var id = this.props.user.id;
        // console.log(this.state.userstate)
        const config = {
            headers: { Authorization: `Bearer ${this.props.user.token}` }
        };
          try{
          let result = await axios.get(`${baseUrl}users/${id}`,
          config,
          {
          cancelToken:this.source.token});
          return result;
          
          }catch (error) {
            if (axios.isCancel(error)) {
              console.log("Request canceled", error.message);
              throw new Error("Cancelled");
            }
          }
        
        };

  fetchModule = async () => {
    try{
    let result = await axios.get(`${baseUrl}modules`,{
    cancelToken:this.source.token});
    return result;
    
    }catch (error) {
      if (axios.isCancel(error)) {
        console.log("Request canceled", error.message);
        throw new Error("Cancelled");
      }
    }
  
  };
  


    componentDidMount = () =>{
        this.fetchUser()
        .then((response) => {
        // console.log(response.data)
        this.setState({
          //user:Array.from(response.data),
          userstate:response.data,
        })
            this.fetchModule()
            .then((response) => {
            //console.log(response.data)
            var topicData=[];
               Array.from(response.data).map((item)=>
               {
                        //console.log(typeof item.topic)
                        item.topic.map(elem =>{
                            if(typeof elem.label !=="undefined"){
                            topicData.push({
                                label:elem.label,
                                value:elem.value
                            })
                            }
                        })
                    
               }) 
            //console.log(topicData)
           

            //let unique = [...new Set(topicData.map(item=>item.label))];
            let unique =  findUnique(topicData, d => d.label)
            //console.log(unique); 
            this.setState({
                module:unique,

                isLoading:!this.state.isLoading 
                })

           
            })
        })
        .catch((error)=>{
        console.log(error);
        });
    }
  

///////////////////////////////////////////////////////////////
///code for tags creation
handleChange = (newValue, actionMeta) => {
    console.group('Value Changed');
    this.setState({
        topic:newValue
    })
    console.log(newValue);
    console.log(`action: ${actionMeta.action}`);
    console.groupEnd();
  };

handleAccordionChange = (panel) => (event, isExpanded) => {
    console.log(panel)
    if(isExpanded){
        this.setState({
            expanded:panel
        })
    }else{
        this.setState({
            expanded:false
        }) 
    }
  };

    validateTopic(value) {
        let error;
        //console.log(value);
        if(this.state.topic ==''){
              error = 'Please enter appropriate topic'
           }
        return error;
      }
      
    validateAnalysis(value) {
        let error;
        //console.log(value);
        if(this.state.analysis ==''){
              error = 'Please enter analysis for the module'
           }
        return error;
      }

      handleAnalysisChange(event){
        this.setState({
            analysis:event.target.value,
          })
    }

    validateMethod(value) {
        let error;
        //console.log(value);
        if(this.state.method ==''){
              error = 'Please enter method for the module'
           }
        return error;
      }

      handleMethodChange(event){
        this.setState({
            method:event.target.value,
          })
    }

    validateMaterial(value) {
        let error;
        //console.log(value);
        if(this.state.material ==''){
              error = 'Please enter material for the module'
           }
        return error;
      }

      handleMaterialChange(event){
        this.setState({
            material:event.target.value,
          })
    }

    validateTask(value) {
        let error;
        //console.log(value);
        if(this.state.task ==''){
              error = 'Please enter task for the module'
           }
        return error;
      }

      handleTaskChange(event){
        this.setState({
            task:event.target.value,
          })
    }

    validateSimName(value) {
        let error;
        //console.log(value);
        if(this.state.simulation_name ==''){
              error = 'Please enter simulation name'
           }
        return error;
      }

      handleSimNameChange(event){
        this.setState({
            simulation_name:event.target.value,
          })
    }

    handleClosePreview() {
        this.setState({
          open:!this.state.open
        });
      }
      cancelbutton() {
        this.setState({
          file:'',
          url:''
        });
      }
      cancelSimbutton() {
        this.setState({
          simfile:'',
        });
      }
      cancelImagebutton() {
        this.setState({
          imagefile:'',
          imageurl:''
        });
      }
      cancelBackGroundbutton() {
        this.setState({
          backfile:'',
          backurl:''
        });
      }
      cancelMaterialbutton() {
        this.setState({
          matfile:'',
          maturl:''
        });
      }
      cancelMethodbutton() {
        this.setState({
          methodfile:'',
          methodurl:''
        });
      }
      cancelAnalysisbutton() {
        this.setState({
          analysisfile:'',
          analysisurl:''
        });
      }
    uploadbutton(){
        const data=new FormData();
        //// imageFile is set as single key in backend 
        data.append('file', this.state.file)   
        let url = "http://localhost:5000/fileupload/files";

    
        axios.post(url, data)
        .then(response => {
            this.setState({
                modimage:response.data.file.filename,
                uploadSuccess:!this.state.uploadSuccess,
              })
            // console.log(response)
        })
        .catch(errors => console.log(errors));
    
    }

    uploadsimbutton(){
        const data=new FormData();
        //// imageFile is set as single key in backend 
        data.append('file', this.state.simfile)   
        let url = "http://localhost:5000/fileupload/files";
    
        axios.post(url, data)
        .then(response => {
            this.setState({
                simulation:response.data.file.filename,
                uploadSimSuccess:!this.state.uploadSimSuccess,
              })

            // console.log(response.data.file.filename)

        })
        .catch(errors => console.log(errors));
    
    }
    uploadimagebutton(){
        const data=new FormData();
        //// imageFile is set as single key in backend 
        data.append('file', this.state.imagefile)   
        let url = "http://localhost:5000/fileupload/files";
    
        axios.post(url, data)
        .then(response => {
            this.setState({
                intro_image:response.data.file.filename,
                uploadImageSuccess:!this.state.uploadImageSuccess,
              })
            // console.log(response.data.file.filename)
        })
        .catch(errors => console.log(errors));
    
    }
    uploadimageBackbutton(){
        const data=new FormData();
        //// imageFile is set as single key in backend 
        data.append('file', this.state.backfile)   
        let url = "http://localhost:5000/fileupload/files";
    
        axios.post(url, data)
        .then(response => {
            this.setState({
                backGroundImage:response.data.file.filename,
                uploadImageSuccess:!this.state.uploadImageSuccess,
              })
            console.log(response.data.file.filename)
        })
        .catch(errors => console.log(errors));
    
    }

    uploadimageMaterialbutton(){
        const data=new FormData();
        //// imageFile is set as single key in backend 
        data.append('file', this.state.matfile)   
        let url = "http://localhost:5000/fileupload/files";
    
        axios.post(url, data)
        .then(response => {
            this.setState({
                materialImage:response.data.file.filename,
                uploadImageSuccess:!this.state.uploadImageSuccess,
              })
           // console.log(response.data.file.filename)
        })
        .catch(errors => console.log(errors));
    
    }

    uploadimageMethodbutton(){
        const data=new FormData();
        //// imageFile is set as single key in backend 
        data.append('file', this.state.methodfile)   
        let url = "http://localhost:5000/fileupload/files";
    
        axios.post(url, data)
        .then(response => {
            this.setState({
                methodImage:response.data.file.filename,
                uploadImageSuccess:!this.state.uploadImageSuccess,
              })
            //console.log(response.data.file.filename)
        })
        .catch(errors => console.log(errors));
    
    }

    uploadimageAnalysisbutton(){
        const data=new FormData();
        //// imageFile is set as single key in backend 
        data.append('file', this.state.analysisfile)   
        let url = "http://localhost:5000/fileupload/files";
    
        axios.post(url, data)
        .then(response => {
            this.setState({
                analysisImage:response.data.file.filename,
                uploadImageSuccess:!this.state.uploadImageSuccess,
              })
            //console.log(response.data.file.filename)
        })
        .catch(errors => console.log(errors));
    
    }

/////////////////function to upload image for each form section///////////////////////////////////
    handleUploadClick(event){
    // this.setState({
    //     file: event.target.files[0],
    //     url: URL.createObjectURL(event.target.files[0])
    //   })

      let reader = new FileReader();
      let file = event.target.files[0];
      this.setState({
        file: event.target.files[0],
      })
      var url = reader.readAsDataURL(file)
  
      reader.onloadend = () => {
        this.setState({
            url: reader.result,
          })
        } 
      
      if(this.state.uploadSuccess===true){
        this.setState({
            uploadSuccess:!this.state.uploadSuccess
          }) 
      }
    };

    handleSimUploadClick(event){
        this.setState({
            simfile: event.target.files[0],

          })
          
          if(this.state.uploadSimSuccess===true){
            this.setState({
                uploadSimSuccess:!this.state.uploadSimSuccess
              }) 
          }
        };
        handleImageUploadClick(event){
            //console.log('Image upload started')
            this.setState({
                imagefile: event.target.files[0],
                imageurl: URL.createObjectURL(event.target.files[0])
              })

        
              
              if(this.state.uploadImageSuccess===true){
                this.setState({
                    uploadImageSuccess:!this.state.uploadImageSuccess
                  }) 
              }
            };
            handleBackUploadClick(event){
                //console.log('Image upload started')
                this.setState({
                    backfile: event.target.files[0],
                    backurl: URL.createObjectURL(event.target.files[0])
                  })
               
                  
                  if(this.state.uploadImageSuccess===true){
                    this.setState({
                        uploadImageSuccess:!this.state.uploadImageSuccess
                      }) 
                }
            };
            handleMaterialUploadClick(event){
                //console.log('Image upload started')
                this.setState({
                    matfile: event.target.files[0],
                    maturl: URL.createObjectURL(event.target.files[0])
                  })

                
                  
                  if(this.state.uploadImageSuccess===true){
                    this.setState({
                        uploadImageSuccess:!this.state.uploadImageSuccess
                    }) 
                }
            }; 
            handleMethodUploadClick(event){
                // console.log('Image upload started')
                this.setState({
                    methodfile: event.target.files[0],
                    methodurl: URL.createObjectURL(event.target.files[0])
                  })
                
                  
                  if(this.state.uploadImageSuccess===true){
                    this.setState({
                        uploadImageSuccess:!this.state.uploadImageSuccess
                    }) 
                }
            };
            handleAnalysisUploadClick(event){
                // console.log('Image upload started')
                this.setState({
                    analysisfile: event.target.files[0],
                    analysisurl: URL.createObjectURL(event.target.files[0])
                  })

               
                  
                  if(this.state.uploadImageSuccess===true){
                    this.setState({
                        uploadImageSuccess:!this.state.uploadImageSuccess
                    }) 
                }
            };           
///////function to add youtube video///////////////////////////////////// 
    handlevideo = (event) => {
        if(event.target.value){
        this.setState({
            youtube: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))
        
          })
        }else{
            this.setState({you: ''})

        }
        };

    handleBackvideo = (event) => {
            if(event.target.value){
            this.setState({
                backGroundYou: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))
            
              })
        }
        else
        {
            this.setState({backGroundYou: ''})
    
        }
    };
    handleMaterialvideo = (event) => {
                if(event.target.value){
                this.setState({
                    materialYou: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))
                
                  })
                }else{
                    this.setState({materialYou: ''})
        
                }
                };

    handleMethodvideo = (event) => {
        if(event.target.value){
        this.setState({
            methodYou: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))      
            
        })
        }else{
            this.setState({methodYou: ''})
    
        }
        };
    
        handleAnalysisvideo = (event) => {
            if(event.target.value){
            this.setState({
                analysisYou: "https://www.youtube.com/embed/".concat(event.target.value.replace("https://www.youtube.com/watch?v=", "").substring(0,11))      
                
            })
            }else{
                this.setState({analysisYou: ''})
        
            }
        };
///////////////////////////////////////////////////////////////////////////////////

    onenable(){
        this.setState({expdisable:!this.state.expdisable})

    } 
     htmlPage(){
        if(typeof window.GGBApplet !== 'undefined'){
        var ggbApp = new window.GGBApplet({filename:`http://localhost:5000/fileupload/files/${this.state.simulation}`, "width": 1000, "height": 800, "showFullscreenButton":true }, true);
        }
        const apploader = () =>{

            //window.addEventListener('click', function(event) {
            // console.log(event.target.textContent)
              //  if(event.target.textContent === 'Upload Simulation'){
                    ggbApp.inject('ggb-elem');
                //}
                
                //})
            }
                
        
        return(
        this.myref!==null?
          <div id="header" className="row">
            <meta name='viewport' content="width=device-width,initial-scale=1"></meta>
            <meta charSet="utf-8"/>
            <div id="ggb-elem">
            </div>          
            {apploader()}
          </div>:null
        );

      }
      handlelevelChange(event){
        this.setState({level: event.target.value})
      }

      getPreview(){
          console.log(this.state.preview)
          this.setState({
            open:!this.state.open
          });
      }

    onEditorStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            intro:editor.getData()
        })
      };

      onEditorBackGroundStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            backGround:editor.getData()
        })
      };
      onEditorTaskStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            task:editor.getData()
        })
      };
      onEditorMaterialStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            material:editor.getData()
        })
      };
      onEditorMethodStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            method:editor.getData()
        })
      };
      onEditorAnalysisStateChange = (event, editor) => {
        //console.log(JSON.stringify(convertToRaw(editorState.getCurrentContent())))
        this.setState({
            analysis:editor.getData()
        })
      };

    uploadImageCallBack = (file) =>{
        

        // We need to return a promise with the image src
        // the img src we will use here will be what's needed
        // to preview it in the browser. This will be different than what
        // we will see in the index.md file we generate.
        return new Promise(
          (resolve, reject) => {
          const data=new FormData();
          data.append('file', file)   
          var filename = '';
        axios.post(`http://localhost:5000/fileupload/files`, data)
                .then((response) => {
                    console.log(response.data.file.filename)
                    filename = response.data.file.filename;
                    resolve({ 
                      data: { link: `http://localhost:5000/fileupload/files/${filename}` } 
                    })
         })
           
          }
        );
      }


  
     



      


    render(){
           
        const { classes } = this.props;
        
        console.log(this.state.topic)

      return (
       
        
           <GridContainer>
               <Breadcrumbs separator={<NavigateNextIcon fontSize="small" />} aria-label="breadcrumb">
                    {/* <Link color="inherit" to="/admin/home">
                        Home
                    </Link> */}
                     {typeof this.props.params.classId!=='undefined'?
                    <Link color="inherit" to="/admin/dashboard">
                        Dashboard
                    </Link>
                    :<Link color="inherit" to="/admin/home">
                        Home
                    </Link>
                    }

                    {typeof this.props.params.classId!=='undefined'?
                    <Link color="inherit" to={`/admin/dashboard/createsession/${this.props.params.classId}`}> 
                        <Typography color="textPrimary">Create new Session</Typography>
                    </Link>:null
                    }
                <Typography color="textPrimary">Create Module</Typography>
                </Breadcrumbs>
                <Formik
                    initialValues={{
                    title: '',
                    language: '',
                    autocomplete: '',
                    description: '',
                    level: this.state.level,
                    subject:'',
                    std: '',
                    modimage:'',
                    youtube:'',
                    simulation_name:'',
                    simulation:'',
                    intro_image:'',
                    intro:'',
                    backGround:'',
                    backGroundYou:'',
                    backGroundImage:'',
                    task:'',
                    material:'',
                    materialYou:'',
                    materialImage:'',
                    method:'',
                    methodYou:'',
                    methodImage:'',
                    analysis:'',
                    analysisYou:'',
                    analysisImage:''


                    }}

                   validationSchema={validationSchema}

                    onSubmit={(values, {setSubmitting}) => {
                    setTimeout(() => {
                        setSubmitting(false);
                        {(this.state.file !== '') ? values.modimage=this.state.modimage: values.modimage='assets/images/m_pic.jpg' }
                    var empty = true;

                    if(this.state.topic.length==0){
                        this.setState({
                            errorTopic:'Please enter related topics for the module'
                        })
                    }
                    else{
                        this.setState({
                            errorTopic:''
                        }) 

                        var emptyIntro=true;
                        const Introdata = this.state.intro;
                        
                    
                        if(Introdata !== ''){
                            emptyIntro=false
                        }
                        if(emptyIntro==true){
                            this.setState({
                                errorIntro:'Please enter Introduction for the module'
                            })
                        }
                        else{
                            this.setState({
                                errorIntro:''
                            })
                        }

                        const Backdata = this.state.backGround;
                        var emptyBack=true;
                        
                    
                        if(Backdata!== ''){
                            emptyBack=false
                        }
                        if(emptyBack==true){
                            this.setState({
                                errorBack:'Please enter BackGround for the module'
                            })
                        }
                        else{
                            this.setState({
                                errorBack:''
                            })
                        }
                        
                        /////check data for task part
                        if(this.state.level=='1'|| this.state.level=='2'||this.state.level=='3'){
                            var emptyTask=true;
                            const Taskdata = this.state.task;
                        
                            if(Taskdata!== ''){
                                emptyTask=false
                            }
                            if(emptyTask==true){
                                this.setState({
                                    errorTask:'Please enter required task for the module'
                                })
                            }
                            else{
                                this.setState({
                                    errorTask:''
                                })
                            }
                        }

                        //////Check data for materials and method

                        if(this.state.level=='1'|| this.state.level=='2'){
                            var emptyMat=true;
                            var emptyMet=true;

                            const Materialdata = this.state.material;
                            const Methoddata = this.state.method;
                            
                        
                            if(Materialdata !== ''){
                            emptyMat=false
                            }
                            if(emptyMat==true){
                                this.setState({
                                    errorMaterial:'Please enter required Material for the module'
                                })
                            }
                            else{
                                this.setState({
                                    errorMaterial:''
                                })
                            }
                        
                            if(Methoddata !== ''){
                            emptyMet=false
                            }
                            if(emptyMet==true){
                                this.setState({
                                    errorMethod:'Please enter required Method for the module'
                                })
                            }
                            else{
                                this.setState({
                                    errorMethod:''
                                })
                            }
                        }

                        //////Check data for analysis
                        if(this.state.level=='1'){
                            var emptyAnalysis=true;
                            const Analysisdata = this.state.analysis; 
                        
                            if(Analysisdata !== ''){
                                emptyAnalysis=false
                            }
                            if(emptyAnalysis==true){
                                this.setState({
                                    errorAnalysis:'Please enter Analysis for the module'
                                })
                            }
                            else{
                                this.setState({
                                    errorAnalysis:''
                                })
                            }
                        }

                        if(this.state.level=='1'){
                            if(emptyIntro===false && emptyBack===false && emptyTask===false && emptyMat===false
                                && emptyMet===false&& emptyAnalysis===false){
                                    empty=false
                            }
                            else{
                                empty=true;
                            }
                            
                        }
                        else if(this.state.level=='2'){
                            if(emptyIntro===false && emptyBack===false && emptyTask===false && emptyMat===false
                                && emptyMet===false){
                                    empty=false
                            }
                            else{
                                empty=true;
                            }
                        }
                        else if(this.state.level=='3'){
                            if(emptyIntro===false && emptyBack===false && emptyTask===false){
                                    empty=false
                            }
                            else{
                                empty=true;
                            }
                        }
                        else if(this.state.level=='4'){
                            if(emptyIntro===false && emptyBack===false){
                                    empty=false
                            }
                            else{
                                empty=true;
                            }
                        }


                        values.intro=this.state.intro;
                        values.backGround=this.state.backGround;
                        values.youtube = this.state.youtube;
                        values.simulation= this.state.simulation;
                        values.intro_image = this.state.intro_image;
                        values.analysis=this.state.analysis;
                        values.material=this.state.material;
                        values.method=this.state.method;
                        values.task=this.state.task;
                        values.simulation_name = this.state.simulation_name;
                        //alert(JSON.stringify(values, null, 2));

                        if(empty===false){
                            const moduleDetails = {
                                name: values.title,
                                image:values.modimage,
                                youtube:values.youtube,
                                language:values.language,
                                level:this.state.level,
                                topic:this.state.topic,
                                subject:values.subject,
                                std:values.std,
                                rating:'',
                                description:values.description,
                                simulation_name:values.simulation_name,
                                simulation:values.simulation,
                                intro_image:values.intro_image,
                                intro:values.intro,
                                backGround:values.backGround,
                                backGroundYou:this.state.backGroundYou,
                                backGroundImage:this.state.backGroundImage,
                                task:values.task,
                                material:values.material,
                                materialYou:this.state.materialYou,
                                materialImage:this.state.materialImage,
                                method:values.method,
                                methodYou:this.state.methodYou,
                                methodImage:this.state.methodImage,
                                analysis:values.analysis,
                                analysisYou:this.state.analysisYou,
                                analysisImage:this.state.analysisImage,
                                author_id:this.state.userstate._id,
                                author:this.state.userstate.username,
                            }
                            console.log(moduleDetails)
                            
                            axios.post('http://localhost:5000/modules', moduleDetails)
                            .then(res => 
                                {
                                    if(typeof this.props.params.classId !=='undefined'){
                                        window.location = `/admin/dashboard/createsession/${this.props.params.classId}/${res.data._id}`

                                    }
                                    else{
                                        window.location = "/admin"

                                    }
                                    //console.log(res.data)   
                                });
                            }

                    }
                }, 500);
                    }}
                >
                    {({submitForm, isSubmitting, touched, errors, values}) => (
                        <Form>
                       
                        <Grid container>

                            <Card>
                                <CardHeader color="primary">
                                    <StyledcardTitle>
                                        <p>Enter basic details</p>
                                    </StyledcardTitle>
                                </CardHeader> 
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel2'} onChange={this.handleAccordionChange('panel2')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <StyledHeading>
                                            <Typography>Basic details</Typography>
                                        </StyledHeading>
                                        <StyledSecondaryHeading>
                                            <Typography>
                                                This tab contains Basic details
                                            </Typography>
                                        </StyledSecondaryHeading>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            label="Title"
                                            name="title"
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={2}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            label="Language"
                                            name="language"
                                            select
                                            variant="standard"
                                            helperText="Please select language"
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                             {language.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                            </Field>
                                        </GridItem>

                                        {this.state.isLoading!== true?
                                        <GridItem xs={12} sm={12} md={3} 
                                        >
                                           <CreatableSelect
                                                isMulti
                                                onChange={this.handleChange}
                                                options={this.state.module}
                                                //defaultValue={options}
                                                placeholder="Select or create Topic"
                                            />
                                            <p>{this.state.errorTopic}</p>
                                        <p>To create new topic-type and press enter</p>
                                        </GridItem>:null}
                                        {console.log(values)}

                                        <GridItem xs={12} sm={12} md={4}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            label="Brief Description"
                                            name="description"
                                            fullWidth= {true} 
                                            />
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>
                                            <Field
                                            component={TextField}
                                            type="text"
                                            onChange={this.handlelevelChange}
                                            value={this.state.level}
                                            name="level"
                                            label="Level"
                                            select
                                            variant="standard"
                                            helperText="Please select level of module"
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {levelmod.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                            </Field>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={3}>

                                            <Field
                                            component={TextField}
                                            type="text"
                                            name="subject"
                                            label="Subject"
                                            select
                                            variant="standard"
                                            helperText="Please select the subject"
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {subject.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                            </Field>

                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={2}>

                                            <Field
                                            component={TextField}
                                            type="text"
                                            name="std"
                                            label="std"
                                            select
                                            variant="standard"
                                            helperText="Please select"
                                            margin="normal"
                                            InputLabelProps={{
                                                shrink: true,
                                            }}
                                            >
                                            {standard.map((option) => (
                                                <MenuItem key={option.value} value={option.value}>
                                                {option.label}
                                                </MenuItem>
                                            ))}
                                            </Field>

                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <p>Upload thumbnail for Module</p>
                                            <label htmlFor="modimage">
                                                <input
                                                accept="image/*"
                                                style={{ display: "none" }}
                                                id="modimage"
                                                //multiple
                                                type="file"
                                                name="modimage"
                                                label="Upload image here"
                                                onChange={this.handleUploadClick}
                                                />
                                                    <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                        <InsertPhotoIcon /> Add Image
                                                    </Fab>
                                            </label>
                                            {this.state.file!=='' ?this.state.uploadSuccess!==true?
                                            <div>
                                            <Button color="success" onClick={this.uploadbutton}>
                                                upload 
                                            </Button>
                                            <Button color="danger" onClick={this.cancelbutton}>
                                                cancel 
                                            </Button></div>:<p>
                                                uploaded successfully
                                            </p>:null}
                                            <img src={this.state.url} style={previewStyle}/>
                                        </GridItem>
                                      </GridContainer>
                                    </AccordionDetails>
                                  </Accordion>
                                </CardBody>
                            </Card>
                            
                            <Card>
                                <CardHeader color="primary">
                                    <StyledcardCategory>
                                        <p>Introduction to Module</p>
                                    </StyledcardCategory>
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel4'} onChange={this.handleAccordionChange('panel4')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <StyledHeading>
                                            <Typography>Introduction</Typography>
                                        </StyledHeading>
                                        <StyledSecondaryHeading>
                                            <Typography>
                                                This tab contains Introduction part
                                            </Typography>
                                        </StyledSecondaryHeading>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={4}>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                    <p>Add video for Introduction part</p>
                                                        <Field
                                                        component={TextField}
                                                        value={this.state.youtube}
                                                        type="text"
                                                        label="Enter youtube shared link"
                                                        name="youtube"
                                                        onChange={this.handlevideo}
                                                        />
                                                        {this.state.youtube!=='' ? <iframe src={this.state.youtube}
                                                        allow='autoplay; encrypted-media'
                                                        allowFullScreen={true}
                                                        title='video'
                                                        /> : <p>Please enter correct link</p>}
                                                    </GridItem>
                                                
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <p>Upload image for Hypothesis part</p>
                                                        <label htmlFor="intro_image">
                                                            <input
                                                            accept="application/pdf"
                                                            style={{ display: "none" }}
                                                            id="intro_image"
                                                            //multiple
                                                            type="file"
                                                            name="intro_image"
                                                            label="Upload image here"
                                                            onChange={this.handleImageUploadClick}
                                                            />
                                                            
                                                            <Fab color="secondary" aria-label="add" 
                                                            variant="extended"
                                                            size="medium"
                                                            component="span">
                                                                <PictureAsPdfIcon /> Add Pdf
                                                            </Fab>
                                                        </label>
                                                        {this.state.imagefile!=='' ?this.state.uploadImageSuccess!==true?
                                                        <div>
                                                        <Button color="success" onClick={this.uploadimagebutton}>
                                                            upload 
                                                        </Button>
                                                        <Button color="danger" onClick={this.cancelImagebutton}>
                                                            cancel 
                                                        </Button></div>:<p>
                                                            uploaded successfully
                                                        </p>:null}
                                                        {this.state.imagefile!=='' ?
                                                        <iframe src={this.state.imageurl} width="300px" height="400px" ></iframe>
                                                        :null}
                                                        </GridItem>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                    {this.state.simfile!=='' ?
                                                        <Field
                                                        component={TextField}
                                                        type="text"
                                                        label="Enter simulation name"
                                                        name="simulation_name"
                                                        value={this.state.simulation_name}
                                                        onChange={this.handleSimNameChange}
                                                        validate={this.validateSimName}
                                                        //fullWidth= {true} 
                                                        />:null}
                                                    </GridItem>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <p>Upload Simulation for module</p>
                                                        <label htmlFor="modsimulation">
                                                            <input
                                                            accept=".ggb"
                                                            style={{ display: "none" }}
                                                            id="modsimulation"
                                                            //multiple
                                                            type="file"
                                                            name="modsimulation"
                                                            label="Upload simulation here"
                                                            onChange={this.handleSimUploadClick}
                                                            />
                                                            <Fab color="secondary" aria-label="add"
                                                            variant="extended"
                                                            size="medium"
                                                            component="span">
                                                                <AttachFileIcon /> Add Simulation
                                                            </Fab>
                                                        </label>
                                                        {this.state.simfile!=='' ?this.state.uploadSimSuccess!==true?
                                                        <div>
                                                            <Button color="success" onClick={this.uploadsimbutton}>
                                                                Upload Simulation 
                                                            </Button>
                                                            <Button color="danger" onClick={this.cancelSimbutton}>
                                                                cancel 
                                                            </Button></div>:<p>
                                                            uploaded successfully(Click on preview to load here)
                                                        </p>:null}
                                                        {/* {console.log(this.state.simulation)} */}
                                                        {typeof window.GGBApplet !== 'undefined'? 
                                                        this.state.simulation !== ''?
                                                        this.htmlPage():null:null}
                                                    </GridItem>
                                                    {/* {console.log(this.state.simfile)} */}

                                                
                                                </GridContainer>
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={8}>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <CKEditor
                                                            required
                                                            editor={ ClassicEditor }
                                                            data={this.state.intro}
                                                            config={custom_config}
                                                            onReady={ editor => {
                                                                // You can store the "editor" and use when it is needed.
                                                                console.log( 'Editor is ready to use!', editor );
                                                            } }
                                                            onChange={(event, editor)=>this.onEditorStateChange(event, editor)}
                                                            onBlur={ ( event, editor ) => {
                                                                //console.log( 'Blur.', editor );
                                                            } }
                                                            onFocus={ ( event, editor ) => {
                                                                //console.log( 'Focus.', editor );
                                                            } }
                                                            />


                                                    </GridItem>
                                                    
                                                </GridContainer>
                                            </GridItem>
                                        </GridContainer>
                                    </AccordionDetails>
                                    </Accordion>
                                    <p>{this.state.errorIntro}</p>

                                </CardBody>
                            </Card>
                           
                        {this.state.level === '1'|| this.state.level === '2' || this.state.level === '3'? 
                            <Card>
                                <CardHeader color="primary">
                                    <StyledcardCategory>
                                        <p> Task</p>
                                    </StyledcardCategory>
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel5'} onChange={this.handleAccordionChange('panel5')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <StyledHeading>
                                            <Typography>Task</Typography>
                                        </StyledHeading>
                                        <StyledSecondaryHeading>
                                            <Typography>
                                                This tab contains task details
                                            </Typography>
                                        </StyledSecondaryHeading>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>
                            
                                        <GridItem xs={12} sm={12} md={12}>
                                                    
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.task}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorTaskStateChange(event, editor)}
                                                        
                                                        />
                                        </GridItem>
                                    </GridContainer>
                                  </AccordionDetails>
                                </Accordion>
                                <p>{this.state.errorTask}</p>

                                </CardBody>
                            </Card>:null}
                            <Card>
                                <CardHeader color="primary">
                                    <StyledcardCategory>
                                        <p>BackGround</p>
                                    </StyledcardCategory>
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel6'} onChange={this.handleAccordionChange('panel6')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <StyledHeading>
                                            <Typography>BackGround</Typography>
                                        </StyledHeading>
                                        <StyledSecondaryHeading>
                                            <Typography> 
                                                This tab contains Background of the module
                                            </Typography>
                                        </StyledSecondaryHeading>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={4}>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={12}>
                                                <p>Add video for Background part</p>
                                                    <Field
                                                    component={TextField}
                                                    value={this.state.backgroundYou}
                                                    type="text"
                                                    label="Enter youtube shared link"
                                                    name="backgroundYou"
                                                    onChange={this.handleBackvideo}
                                                    />
                                                    {/* {console.log(this.state.backGroundYou)} */}
                                                    {this.state.backGroundYou!=='' ? <iframe src={this.state.backGroundYou}
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                    /> : <p>Please enter correct link</p>}
                                                </GridItem>
                                               
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p>Upload image for BackGround part</p>
                                                    <label htmlFor="back_image">
                                                        <input
                                                        accept="application/pdf"
                                                        style={{ display: "none" }}
                                                        id="back_image"
                                                        //multiple
                                                        type="file"
                                                        name="back_image"
                                                        label="Upload image here"
                                                        onChange={this.handleBackUploadClick}
                                                        />
                                                        
                                                        <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                            <PictureAsPdfIcon /> Add Pdf
                                                        </Fab>
                                                    </label>
                                                    {this.state.backfile!=='' ?this.state.uploadImageSuccess!==true?
                                                    <div>
                                                    <Button color="success" onClick={this.uploadimageBackbutton}>
                                                        upload 
                                                    </Button><Button color="danger" onClick={this.cancelBackGroundbutton}>
                                                        cancel 
                                                    </Button></div>:<p>
                                                        uploaded successfully
                                                    </p>:null}
                                                    {this.state.backfile!=='' ?
                                                    <iframe src={this.state.backurl} width="300px" height="400px" ></iframe>
                                                    :null}
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={8}>
                                                    
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.backGround}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorBackGroundStateChange(event, editor)}
                                                        
                                                        />

                                        </GridItem>
                                    </GridContainer>
                                    </AccordionDetails>
                                  </Accordion>
                                  <p>{this.state.errorBack}</p>

                                </CardBody>
                            </Card>
                        {this.state.level === '1'|| this.state.level === '2' ?

                            <Card>
                                <CardHeader color="primary">
                                    <StyledcardCategory>
                                        <p> Material</p>
                                    </StyledcardCategory>
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel7'} onChange={this.handleAccordionChange('panel7')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <StyledHeading>
                                            <Typography>Material part</Typography>
                                        </StyledHeading>
                                        <StyledSecondaryHeading>
                                            <Typography>
                                                This tab contains necessary materials required for the module
                                            </Typography>
                                        </StyledSecondaryHeading>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={4}>
                                                <GridContainer>
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <p>Add video for Material part</p>
                                                        <Field
                                                        component={TextField}
                                                        value={this.state.materialYou}
                                                        type="text"
                                                        label="Enter youtube shared link"
                                                        name="youtube"
                                                        onChange={this.handleMaterialvideo}
                                                        />
                                                        {this.state.materialYou!=='' ? <iframe src={this.state.materialYou}
                                                        allow='autoplay; encrypted-media'
                                                        allowFullScreen={true}
                                                        title='video'
                                                        /> : <p>Please enter correct link</p>}
                                                    </GridItem>
                                                
                                                    <GridItem xs={12} sm={12} md={12}>
                                                        <p>Upload image for Material part</p>
                                                        <label htmlFor="material_image">
                                                            <input
                                                            accept="application/pdf"
                                                            style={{ display: "none" }}
                                                            id="material_image"
                                                            //multiple
                                                            type="file"
                                                            name="material_image"
                                                            label="Upload image here"
                                                            onChange={this.handleMaterialUploadClick}
                                                            />
                                                            
                                                            <Fab color="secondary" aria-label="add" 
                                                            variant="extended"
                                                            size="medium"
                                                            component="span">
                                                                <PictureAsPdfIcon /> Add Pdf
                                                            </Fab>
                                                        </label>
                                                        {this.state.matfile!=='' ?this.state.uploadImageSuccess!==true?
                                                        <div>
                                                        <Button color="success" onClick={this.uploadimageMaterialbutton}>
                                                            upload 
                                                        </Button>
                                                        <Button color="danger" onClick={this.cancelMaterialbutton}>
                                                            cancel 
                                                        </Button></div>:<p>
                                                            uploaded successfully
                                                        </p>:null}
                                                        {this.state.matfile!=='' ?
                                                        <iframe src={this.state.maturl} width="300px" height="400px" ></iframe>
                                                        :null}
                                                    </GridItem>
                                            </GridContainer>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={8}>
                                                    
                                                        <CKEditor
                                                            required
                                                            editor={ ClassicEditor }
                                                            data={this.state.material}
                                                            config={custom_config}
                                                            onReady={ editor => {
                                                                // You can store the "editor" and use when it is needed.
                                                                console.log( 'Editor is ready to use!', editor );
                                                            } }
                                                            onChange={(event, editor)=>this.onEditorMaterialStateChange(event, editor)}
                                                        
                                                        />
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>               
                                    </GridContainer>
                                    </AccordionDetails>
                                  </Accordion>
                                  <p>{this.state.errorMaterial}</p>

                                </CardBody>
                            </Card>:null}

                            {this.state.level === '1'|| this.state.level === '2' ?

                            <Card>
                                <CardHeader color="primary">
                                    <StyledcardCategory>
                                        <p>Method</p>
                                    </StyledcardCategory>
                                    
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel8'} onChange={this.handleAccordionChange('panel8')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        
                                        <StyledHeading>
                                            <Typography>Method</Typography>
                                        </StyledHeading>
                                        <StyledSecondaryHeading>
                                            <Typography> 
                                                This tab contains method part
                                            </Typography>
                                        </StyledSecondaryHeading>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={12}>
                                            <GridContainer>
                                                <GridItem xs={12} sm={12} md={4}>
                                                    <GridContainer>
                                                        <GridItem xs={12} sm={12} md={12}>
                                                        <p>Add video for method part</p>
                                                            <Field
                                                            component={TextField}
                                                            value={this.state.methodYou}
                                                            type="text"
                                                            label="Enter youtube shared link"
                                                            name="youtube"
                                                            onChange={this.handleMethodvideo}
                                                            />
                                                            {this.state.methodYou!=='' ? <iframe src={this.state.methodYou}
                                                            allow='autoplay; encrypted-media'
                                                            allowFullScreen={true}
                                                            title='video'
                                                            /> : <p>Please enter correct link</p>}
                                                        </GridItem>
                                                    
                                                        <GridItem xs={12} sm={12} md={12}>
                                                            <p>Upload image for method part</p>
                                                            <label htmlFor="method_image">
                                                                <input
                                                                accept="application/pdf"
                                                                style={{ display: "none" }}
                                                                id="method_image"
                                                                //multiple
                                                                type="file"
                                                                name="method_image"
                                                                label="Upload image here"
                                                                onChange={this.handleMethodUploadClick}
                                                                />
                                                                
                                                                <Fab color="secondary" aria-label="add" 
                                                                variant="extended"
                                                                size="medium"
                                                                component="span">
                                                                    <PictureAsPdfIcon /> Add Pdf
                                                                </Fab>
                                                            </label>
                                                            {this.state.methodfile!=='' ?this.state.uploadImageSuccess!==true?
                                                            <div>
                                                            <Button color="success" onClick={this.uploadimageMethodbutton}>
                                                                upload 
                                                            </Button>
                                                            <Button color="danger" onClick={this.cancelMethodbutton}>
                                                                cancel 
                                                            </Button></div>:<p>
                                                                uploaded successfully
                                                            </p>:null}
                                                            {this.state.methodfile!=='' ?
                                                            <iframe src={this.state.methodurl} width="300px" height="400px" ></iframe>
                                                            :null}
                                                        </GridItem>
                                                    </GridContainer>
                                                </GridItem>
                                                <GridItem xs={12} sm={12} md={8}>
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.method}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorMethodStateChange(event, editor)}
                                                        
                                                    />

                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>                
                                    </GridContainer>
                                  </AccordionDetails>
                                  </Accordion>
                                  <p>{this.state.errorMethod}</p>

                                </CardBody>
                            </Card>:null}

                            {this.state.level === '1'?
                            <Card>
                                <CardHeader color="primary">
                                    <StyledcardCategory>
                                        <p>Analysis</p>
                                    </StyledcardCategory>
                                    
                                </CardHeader>
                                <CardBody>
                                <Accordion expanded={this.state.expanded === 'panel9'} onChange={this.handleAccordionChange('panel9')}>
                                    <AccordionSummary
                                        expandIcon={<ExpandMoreIcon />}
                                        aria-controls="panel2bh-content"
                                        id="panel2bh-header"
                                        >
                                        <StyledHeading>
                                            <Typography>Analysis</Typography>
                                        </StyledHeading>
                                        <StyledSecondaryHeading>
                                            <Typography> 
                                                This tab contains Analysis part of the module
                                            </Typography>
                                        </StyledSecondaryHeading>
                                    </AccordionSummary>
                                    <AccordionDetails>
                                    <GridContainer>
                                        <GridItem xs={12} sm={12} md={4}>
                                        <GridContainer>
                                                <GridItem xs={12} sm={12} md={12}>
                                                <p>Add video for analysis part</p>
                                                    <Field
                                                    component={TextField}
                                                    value={this.state.analysisYou}
                                                    type="text"
                                                    label="Enter youtube shared link"
                                                    name="analysisYou"
                                                    onChange={this.handleAnalysisvideo}
                                                    />
                                                    {this.state.analysisYou!=='' ? <iframe src={this.state.analysisYou}
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                    /> : <p>Please enter correct link</p>}
                                                </GridItem>
                                               
                                                <GridItem xs={12} sm={12} md={12}>
                                                    <p>Upload image for Analysis part</p>
                                                    <label htmlFor="analysis_image">
                                                        <input
                                                        accept="application/pdf"
                                                        style={{ display: "none" }}
                                                        id="analysis_image"
                                                        //multiple
                                                        type="file"
                                                        name="analysis_image"
                                                        label="Upload image here"
                                                        onChange={this.handleAnalysisUploadClick}
                                                        />
                                                        
                                                        <Fab color="secondary" aria-label="add" 
                                                        variant="extended"
                                                        size="medium"
                                                        component="span">
                                                            <PictureAsPdfIcon /> Add Pdf
                                                        </Fab>
                                                    </label>
                                                    {this.state.analysisfile!=='' ?this.state.uploadImageSuccess!==true?
                                                    <div>
                                                        <Button color="success" onClick={this.uploadimageAnalysisbutton}>
                                                            upload 
                                                        </Button>
                                                        <Button color="danger" onClick={this.cancelAnalysisbutton}>
                                                            cancel 
                                                        </Button>
                                                    </div>:<p>
                                                        uploaded successfully
                                                    </p>:null}
                                                    {this.state.analysisfile!=='' ?
                                                    <iframe src={this.state.analysisurl} width="300px" height="400px" ></iframe>
                                                    :null}
                                                </GridItem>
                                            </GridContainer>
                                        </GridItem>
                                        <GridItem xs={12} sm={12} md={8}>
                
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.analysis}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorAnalysisStateChange(event, editor)}
                                                        
                                                    />
                                        </GridItem>
                                    </GridContainer>
                                    </AccordionDetails>
                                  </Accordion>
                                  <p>{this.state.errorAnalysis}</p>

                                </CardBody>
                            </Card>:null}

                            <Modal
                                open={this.state.open}
                                aria-labelledby="form-dialog-title2"
                                aria-describedby="simple-modal-description"
                                onClose={this.handleClosePreview}
                                closeAfterTransition
                                BackdropComponent={Backdrop}
                                BackdropProps={{
                                  timeout: 500,
                                }}
                                >
                                <StyledModal>
                                
                                <Fade in={this.state.open}>
                                    <StyledPaper>
                                      <h3 id="simple-modal-description" align='center'>Module Details</h3>
                                      <h5 id="simple-modal-description" align='center'>Basic Details</h5>
                                      <GridContainer>
                                        <GridItem xs={12} sm={12} md={6}>
                                            <p>Title: {values.title}</p>
                                            <p>Language: {values.language}</p> 
                                            {/* {console.log(this.state.topic)} */}
                                            
                                            <p>Topic: <CreatableSelect
                                                isMulti
                                                onChange={this.handleChange}
                                                options={this.state.module}
                                                defaultValue={this.state.topic}
                                                placeholder="Select or create Topic"
                                            />
                                            </p> 
                                            <p>Description: {values.description}</p> 
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={6}>
 
                                            <p>Level: {values.level}</p> 
                                            <p>Subject: {values.subject}</p> 
                                            <p>Standard: {values.std}</p> 
                                            <p>Module Thumbnail: {this.state.url!=='' ?   
                                                <img src={this.state.url} style={previewStyle}/>:'No Thumbnail Added'}
                                            </p> 
 
                                            </GridItem> 
                                      </GridContainer>
                                      <h5 id="simple-modal-description" align='center'>Introduction to Module</h5>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p id="simple-modal-description">Introduction</p>
                                                
                                                        <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.intro}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorStateChange(event, editor)}
                                                        
                                                        />

                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>YouTubeVideo: 
                                                    {this.state.youtube!=='' ? <iframe src={this.state.youtube}
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                    /> : 'No Video Added'}</p>
                                                <p>Pdf: 
                                                {this.state.imageurl!=='' ?   
                                                    <iframe src={this.state.imageurl} width="300px" height="400px">
                                                    </iframe>
                                                    :'No Pdf Added'}
                                                </p> 
                                                <p>Simulation:{typeof window.GGBApplet !== 'undefined'? 
                                                    this.state.simulation !== ''?
                                                    <div>
                                                    {this.htmlPage()}{values.simulation_name}</div>
                                                    :'No Simulation added'
                                                    :null} </p>  
                                                 
                                            </GridItem>
                                            
                                        </GridContainer>
                                        {this.state.level === '1' || this.state.level === '2' || this.state.level === '3'?
                                        <div>
                                      <h5 id="simple-modal-description" align='center'>Task</h5>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                            {this.state.task!==''?
                                                
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.task}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorTaskStateChange(event, editor)}
                                                        
                                                    />
                                             
                                             :null}  
                                            </GridItem>
                                        </GridContainer>
                                        </div>:null}
                                        <h5 id="simple-modal-description" align='center'>BackGround</h5>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                            <p id="simple-modal-description">Background</p>
                                                {/* <p>{values.backGround}</p> */}
                                                {values.backGround!==''?
                                               
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.backGround}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorBackGroundStateChange(event, editor)}
                                                        
                                                    />
                                                :null}   
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>YouTubeVideo: 
                                                    {this.state.backGroundYou!=='' ? <iframe src={this.state.backGroundYou}
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                    /> : 'No Video Added'}
                                                </p>                                                
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>Pdf: 
                                                    {this.state.backurl!=='' ?   
                                                    <iframe src={this.state.backurl} width="300px" height="400px"></iframe>:'No Pdf Added'}
                                                </p>    
                                            </GridItem>
                                        </GridContainer>
                                        {this.state.level === '1' || this.state.level === '2'?
                                        <div>
                                        <h5 id="simple-modal-description" align='center'>Material</h5>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p id="simple-modal-description">Material</p>
                                                {this.state.material!==''?
                                               
                                                <CKEditor
                                                    required
                                                    editor={ ClassicEditor }
                                                    data={this.state.material}
                                                    config={custom_config}
                                                    onReady={ editor => {
                                                        // You can store the "editor" and use when it is needed.
                                                        console.log( 'Editor is ready to use!', editor );
                                                    } }
                                                    onChange={(event, editor)=>this.onEditorMaterialStateChange(event, editor)}
                                                        
                                                />
                                             :null}
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>YouTubeVideo: 
                                                    {this.state.materialYou!=='' ? <iframe src={this.state.materialYou}
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                    /> : 'No Video Added'}
                                                </p>                                                
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>Pdf: 
                                                    {this.state.maturl!=='' ?   
                                                    <iframe src={this.state.maturl} width="300px" height="400px"></iframe>:'No Pdf Added'}
                                                </p>    
                                            </GridItem>
                                        </GridContainer>
                                        <h5 id="simple-modal-description" align='center'>Method</h5>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p id="simple-modal-description">Method</p>
                                                {/* <p>{values.method}</p> */}
                                            {this.state.method!==''?
                                                
                                                    <CKEditor
                                                        required
                                                        editor={ ClassicEditor }
                                                        data={this.state.method}
                                                        config={custom_config}
                                                        onReady={ editor => {
                                                            // You can store the "editor" and use when it is needed.
                                                            console.log( 'Editor is ready to use!', editor );
                                                        } }
                                                        onChange={(event, editor)=>this.onEditorMethodStateChange(event, editor)}
                                                        
                                                    />
                                             :null}
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>YouTubeVideo: 
                                                    {this.state.methodYou!=='' ? <iframe src={this.state.methodYou}
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                    /> : 'No Video Added'}
                                                </p>                                                
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>Pdf: 
                                                    {this.state.methodurl!=='' ?   
                                                    <iframe src={this.state.methodurl} width="300px" height="400px"></iframe>:'No Pdf Added'}
                                                </p>    
                                            </GridItem>
                                        </GridContainer>
                                        </div>:null}
                                        {this.state.level === '1'?
                                        <div>
                                        <h5 id="simple-modal-description" align='center'>Analysis</h5>
                                        <GridContainer>
                                            <GridItem xs={12} sm={12} md={12}>
                                            <p id="simple-modal-description">Analysis</p>
                                              
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>YouTubeVideo: 
                                                    {this.state.analysisYou!=='' ? <iframe src={this.state.analysisYou}
                                                    allow='autoplay; encrypted-media'
                                                    allowFullScreen={true}
                                                    title='video'
                                                    /> : 'No Video Added'}
                                                </p>                                                
                                            </GridItem>
                                            <GridItem xs={12} sm={12} md={12}>
                                                <p>Pdf: 
                                                    {this.state.analysisurl!=='' ?   
                                                    <iframe src={this.state.analysisurl} width="300px" height="400px"></iframe>:'No Pdf Added'}
                                                </p>    
                                            </GridItem>
                                        </GridContainer>

                                        </div>:null}
                                        <GridItem xs={12}>
                                        <Button
                                            variant="contained"
                                            color="success"
                                            //disabled={isSubmitting}
                                            onClick={this.handleClosePreview}
                                        >
                                        Back to Create Module
                                        </Button>
                                        <Button
                                        variant="contained"
                                        color="primary"
                                        disabled={isSubmitting}
                                        onClick={submitForm}
                                        >
                                        Submit
                                        </Button>
                                
                                        </GridItem>

                                    
                                    </StyledPaper>
                                </Fade>
                                </StyledModal>
                            </Modal>

                            {isSubmitting && <LinearProgress />}
                            <GridItem xs={12}>
                                <Button
                                    variant="contained"
                                    color="success"
                                    //disabled={isSubmitting}
                                    onClick={this.getPreview}
                                >
                                Preview
                                </Button>
                                <Button
                                variant="contained"
                                color="primary"
                                disabled={isSubmitting}
                                onClick={submitForm}
                                >
                                Submit
                                </Button>
                            </GridItem>
                        </Grid>
                        </Form>
                    )}
                </Formik>
        </GridContainer>
      );

  }
}

  export default connect(
  mapStateToProps
)(withRouterCompat(CreateModule));